module.exports = __webpack_public_path__ + "img/拉伸.40a188e3.svg";